import { ApiBaseServiceProvider } from '@/services/api-providers/ApiBaseServiceProvider';
import axios from 'axios';
import { RetentionItem } from '@/@types/RetentionItem';

export class RetentionServiceProvider extends ApiBaseServiceProvider {
  scope = 'retention';

  async listExpiredItems(
    page: number,
    withTotalCount = 0,
    filters?: {
      q?: string;
      workspace?: string;
      author?: string;
      status?: string;
    },
    sorting?: {
      sortBy?: string;
      sortDirection?: 1 | -1;
    }
  ) {
    return axios.get<{ items: RetentionItem[]; itemPerPage: number; totalCount?: number }>(
      this.getBaseUrl() + `items`,
      {
        params: { page, withTotalCount, ...filters, ...sorting },
        ...this.getRequestConfig(),
      }
    );
  }

  async getFiltersData() {
    return axios.get<{ filters: any[] }>(this.getBaseUrl() + `filters`, this.getRequestConfig());
  }

  async count() {
    return axios.get<{ count: number }>(this.getBaseUrl() + `count`, this.getRequestConfig());
  }

  async updateRetentionStatus(id: string, type: 'article' | 'draft', isLongTerm: boolean): Promise<void> {
    await axios.patch(
      this.getBaseUrl() + `items/${id}`,
      {
        type,
        isLongTerm,
      },
      this.getRequestConfig()
    );
  }

  async bulkDeleteContent(
    ids: string[],
    options?: {
      excludeIds?: string[];
      filters?: {
        q?: string;
        workspace?: string;
        author?: string;
        status?: string;
      };
    }
  ): Promise<void> {
    await axios.delete(this.getBaseUrl() + `items`, {
      data: {
        ids,
        excludeIds: options?.excludeIds,
        filters: options?.filters,
      },
      ...this.getRequestConfig(),
    });
  }
}
